module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAuMzg0IiBoZWlnaHQ9IjQyLjU0MSIgdmlld0JveD0iMCAwIDMwLjM4NCA0Mi41NDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTUuMTkyIDM4LjU0MVY0TTMuNSAxNS42OTJMMTUuMTkyIDRMMjYuODg0IDE1LjY5MiIgc3Ryb2tlPSIjMDA5MTY1IiBzdHJva2Utd2lkdGg9IjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/v2/arrow-change-up-no-padding.svg
// module id = moY3
// module chunks = 65